module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "fonta"
  }, [_vm._v("T")]), _vm._v("wo")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('hr', {
    staticClass: "hr"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISSA")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMAN")]), _vm._v(" had four best friends, three of them female and one male. They called themselves the New Hollywood Wives and tried to get together at least once a month, which wasn’t easy, because they were all exceptionally busy—except James, who played house-husband to his black male lover, music mogul Claude St. Lucia.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Look at you ladies go,” James was inclined to say, raising his well-groomed eyebrows. “Why not play it like me and do absolutely nothing? It’s so much "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("easier.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James was tall and English, with fine aristocratic features and dark blond hair, worn a tad too long. He was extremely lazy, but a loyal friend who could be relied upon to listen to all their problems, and among the four women, that meant a lot of problems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa never felt the need to visit a shrink, she had James to depend on, although she didn’t tell him "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("everything,")]), _vm._v(" and she certainly wasn’t about to reveal her suspicions about Gregg.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Today they were meeting at Mr. Chow’s—a longtime popular hangout on Camden Drive.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa got there first, safely delivered by her permanent driver, Chuck, a large, bald, black man who doubled as her bodyguard. She’d learned the hard way that she couldn’t be too careful. She’d had her share of stalkers, freaks, and overzealous fans. Caution was second nature to her now.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then James walked in, debonair as usual in a casual Armani sports jacket and perfectly pressed jeans. James loved clothes; Claude loved buying them for him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor Singer arrived next. Taylor was a tall, striking woman in her mid-thirties, with catlike green eyes, long wavy hair, and well-defined features. She was married to Lawrence Singer, mega Oscar-winning writer/director/producer. Taylor was an actress who had plans to direct and star in her own project—a movie she’d been developing and talking about for two years. So far it hadn’t happened, but with steely determination, and a great deal of help from her powerful husband, she was sure it was about to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was followed by Stella Rossiter, a short, dynamic blonde who produced movies with her husband, Seth—a man thirty years older than his pretty, smart-mouthed third wife. Together they were a well-respected, powerhouse couple who consistently made hit films.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stella was pregnant. Well, actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("she")]), _vm._v(" wasn’t, she was far too busy to put up with the inconvenience of pregnancy. So a mix of "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("her")]), _vm._v(" eggs, fertilized with Seth’s sperm, had been implanted in a surrogate mother. Stella was delighted to inform anyone who would listen that they were about to give birth to twins.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seth’s three grown children from his two former marriages were not thrilled. Nor were his ex-wives.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("And finally, in strolled Kyndra, sultry queen of the divas, making her usual late entrance.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa glanced pointedly at her watch. “What is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("this")]), _vm._v("—black time?” she demanded good-naturedly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, honey,” Kyndra answered in her low-down, smoky voice. “You all would "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("still")]), _vm._v(" be sittin’ here come midnight if this was black time!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everyone laughed, while Kyndra settled into her seat. She was a voluptuous woman, with a huge bosom, long Tina Turner legs, and clouds of thick, dark curls surrounding a strong, sexual face. She’d been married for twenty-four years to Norio Domingo, one of the most successful record producers in the music business. “Come tomorrow, Norio and I are in the recording studio,” Kyndra drawled. “An’ that’s the last you’ll see of us until our party. So get this mama a lychee martini an’ let’s "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("dish!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was Lissa’s lunch, so she signaled the waiter, ordered drinks and all kinds of tempting starters—from chopped seaweed to honey spareribs. The food would probably sit there, as everyone—including James—seemed to be on a permanent diet. But it was a good idea to have it on the table just in case anyone was in an eating mood.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re on, James,” Lissa said, turning to her best male friend. “You "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("always")]), _vm._v(" know everything first, so let’s hear the latest.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that she was interested, since gossip wasn’t her thing, but she needed "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("something")]), _vm._v(" to take her mind off what she was doing later.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well . . .” James said, a knowledgeable glint in his slate-gray eyes. “Did anyone "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hear")]), _vm._v(" about Ricky M. and the two French models?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even better,” Stella interrupted. “I went to one of those ‘how-to-give-the-perfect-blow-job’ parties. Talk about bizarre.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“I")]), _vm._v(" went to one of those,” Taylor said enthusiastically. “Rubber cocks straight out of the dishwasher! And some funny little ex-nurse who tried to instruct everyone how to do it. Can you imagine!”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pu . . . lease,” James said. “It’s far too early for this kind of crude nonsense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ladies,” Kyndra intoned, “if you don’t know how to give the perfect b.j. by this time, then I suggest you pack on up and get your skinny white asses back to where you came from!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And after that it was all systems go.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIVING FAST,")]), _vm._v(" with one hand on the steering wheel, the other clutching her cell phone, Nicci reached Evan on location in Arizona, where he was shooting his latest movie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Busy?” she asked briskly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Busy missing you,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How come you always know the right thing to say?” she said, pleased to hear he was missing her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I hate the thought of practice,” she said, screeching to a halt at a red light.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Practice means there’s been other women. I "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hate")]), _vm._v(" the thought of other women.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No other women,” Evan said solemnly. “I was a virgin before you. All I did was jack off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ugh! I’d sooner there were other women!” she laughed, ignoring the man in the Toyota behind her who was busy giving her the finger on account of her abrupt stop.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No pleasing you today,” Evan said lightly.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“I’m ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("planning on phoning my dad,” she announced, groping for a cigarette in her purse.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? To tell him I jack off?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re weird,” she said, laughing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am,” he agreed. “But you knew that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Uh . . . how’s Brian?” she asked casually, lighting up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“An asshole, as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So things are normal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You could say that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light changed to green, and she shot away, driving too fast, as always. “E-mail me your undying devotion.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I already have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss you,” she said. “Call me later.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She clicked off, a smile on her face. Evan always made her smile, which is more than she could say for most of the men she’d been involved with. Carlos had possessed no sense of humor at all. Looking back, she had no clue what she’d seen in him—apart from his smooth looks and incredible prowess in bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hmm . . . two qualities that shouldn’t count, but definitely did. Sensational sex was hard to come by.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evan was good in bed. Obliging and considerate. But no way was he wild.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci had a strong suspicion that Brian was the wild one in the family. She also had a nagging itch to find out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("No!")]), _vm._v(" she told herself sternly. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Stop thinking that way. It’s Evan you’re marrying. Not Brian, who comes on to every woman who breathes and is certainly not faithful and trustworthy like his brother.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cutting off a white Mercedes driven by a gray-haired letch, she pulled up in front of Starbucks and hurried inside.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Skipping to the front of the line, she winked at the ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("lanky guy behind the counter—a wanna-be actor with bright red hair and crooked teeth. Since he knew her, she didn’t have to tell him her order. “What’s happenin’, Freddy?” she asked, reaching for a cookie on the glass-topped counter.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Courteney Cox was in,” he confided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Cool.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s a babe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“And")]), _vm._v(" taken.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I can look, can’t I?” Freddy said hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you make it big, you can do more than look.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Encouragement,” Freddy said, grinning. “You spur me on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Freddy had no idea who she was, which was good, because Nicci had never traded on being Lissa Roman’s daughter. The less people knew, the better. After all, it wasn’t as if she had any desire to be an actress or a singer. Truth was, she hadn’t decided "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what")]), _vm._v(" she wanted to do. She’d dabbled in a few jobs, just like she’d dabbled in a few drugs. Nicci was an adventurer, anxious to cover every experience.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recently, Evan had suggested that since she obviously had no intention of going to college, and was currently without a job, she might be interested in working with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What as—a gofer?” she’d asked suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, yeah,” he’d answered sarcastically. “I can see "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("you")]), _vm._v(" running errands for people.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hang out on the set—see what gets your adrenaline going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“You")]), _vm._v(" get my adrenaline going,” she’d said warmly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why I love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You love me ’cause we have great sex,” she’d joked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("“I love you ’cause you’re the only woman I can ever imagine spending more than five minutes with.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And this was true, because, unlike his brother, Evan did not have a long, complicated romantic history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Evan, he’d had no serious attachments before her. And that made her feel very special.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m getting married,")]), _vm._v(" she thought, as she left Starbucks, clutching her coffee. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Guess that means no more adventures.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evan had requested a traditional wedding. She’d sort of entertained the idea of running off to Vegas and getting hitched by some kind of Elvis impersonator, but Evan was having none of it. “A runaway wedding would break my mom’s heart,” he’d said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He had a mom! How normal. A widowed mom who lived in New York. They’d flown to New York so that she could meet Nicci. Somehow Nicci had imagined a little old lady in Easy Spirit shoes who wore fluffy angora sweaters and kept cats.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No such luck. Lynda Richter had turned out to be a tall, big-boned woman clad in Escada and diamonds—purchased for her by her sons—with teeth the size of baby tombstones and plenty of overbearing attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci felt quite intimidated by her—especially after she got back to L.A. and had to endure a daily phone call checking up on wedding preparations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have you ordered the cake? The band? Double-checked the place settings? Decided on the flowers? Hired the preacher? Booked a photographer? Chosen your dress? Chosen your "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("bridesmaids’")]), _vm._v(" dresses? What are you waiting for, dear? "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Your wedding is in six weeks.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci dreaded Lynda’s daily phone call. Usually she let her voice mail pick up, but she soon grew annoyed that she was prevented from answering her own phone.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("She’d ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("tried to talk to Evan about it, but, typical male, Evan thought his darling mommy could do no wrong and refused to listen to any form of criticism concerning her.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The saving factor was that Lynda Richter resided in New York. Nicci didn’t think she could have handled it if Lynda had lived around the corner. What a nightmare "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that")]), _vm._v(" would’ve been. Besides, she resented Lynda butting in as if she were a ditzy airhead. She was perfectly capable of planning her own wedding and had everything under control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Well . . . almost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d booked the venue—a gorgeous bluff situated in Palos Verdes, overlooking the Pacific Ocean. The ceremony and reception would take place outside at sunset. Not exactly as traditional as Evan expected, but it would be so romantic. And the woman who ran the place had assured her she could organize whatever Nicci required.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So . . . all she had to do was figure out what she required.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lynda’s list ran through her head like an unrelenting mantra—dress, cake, band, bridesmaids . . . Bridesmaids! God! How traditional was "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Evan was having a best man and six groomsmen, so he’d insisted she have bridesmaids. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Probably so the groomsmen can get laid,")]), _vm._v(" she thought dourly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth was that she was not a girly girl—most of her friends were male. After much thought she’d managed to come up with six suitable candidates. Now all she had to do was get them fitted for dresses. She was well aware that she’d left it horribly late, although her maid of honor, Saffron Domingo, who was also her best friend, had offered to help.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Hmm . . . Saffron was hardly the most reliable person in the world. Like Nicci, Saffron was a free, spirit with not much idea about tradition. The daughter of Kyndra, a diva-style black singer, and Norio Domingo, an eccentric white record producer from Colombia, Saffron was a girl who lived by her own rules. Although she was only nineteen, she had a three-year-old daughter, Lulu, to whom Nicci was godmother. Lulu’s time was divided between living with Saffron in her modest Westwood house and visiting her daddy, famous NBA player, Bronson Livingston, who resided in a huge mansion in a gated community with his second wife and three children—all by different women.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci hated Bronson, in her eyes he was a big, stupid sports star with a giant ego who’d taken advantage of her best friend. And the kicker was he paid minimal child support, and Saffron refused to take him to court to get more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nicci hated him because he’d stolen Saffron’s youth, and the sad thing was that she’d never get it back.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HAVE TO GO,”")]), _vm._v(" Lissa said, clicking her fingers for the check. “It’s been memorable, as usual.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Honey, when "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("I’m")]), _vm._v(" around it’s always memorable,” drawled Kyndra, producing a solid-gold compact and applying an overabundance of purple lip gloss. “Now don’t forget—my anniversary party is coming up soon, and I expect to see you all there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wouldn’t miss it,” everyone chorused.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("“I’m not certain Larry will make it,” Taylor said, her green eyes darting around the restaurant to ascertain if there was anyone important she should say hello to. “He’s in discussion on a big project with James Woods, ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Harrison Ford, and Nick Angel. You know Larry when he immerses himself.”")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’d love to do a movie with Larry,” Lissa said wistfully, reaching for her purse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I believe there "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" a strong female role,” Taylor said thoughtfully. “Once they’re set, they’ll be starting auditions.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("sure,”")]), _vm._v(" Stella said, laughing derisively. “Like "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Lissa")]), _vm._v(" would audition.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“For Larry, I might,” Lissa said, handing the waiter her credit card. “After all, he and Spielberg "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("are")]), _vm._v(" the two finest directors around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I prefer them more cutting edge myself,” Stella remarked. “Such as Guy Ritchie or Sam Mendes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“American Beauty,")]), _vm._v(" an American classic,” James sighed reverently. “Claude and I saw it four times.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?” Taylor said with a bitchy edge. “And which one of you had the hots for Kevin Spacey?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Pu-lease,”")]), _vm._v(" James drawled. “He’s hardly my type.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Everyone’s")]), _vm._v(" your type,” Kyndra joked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("James shot her an “I-do-not-appreciate-jokes-at-my-expense” look.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Personally, I preferred "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Snatch,”")]), _vm._v(" Lissa said. “Guy Ritchie has amazing style.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“We’re")]), _vm._v(" using an excellent director on "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("our")]), _vm._v(" new project,” Stella said, picking a lychee from a dish set in the middle of the table. “A young English guy who’s shot several award-winning television commercials.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lots of luck, dear,” James interjected. “TV directors are notorious for going way over budget—"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("especially")]), _vm._v(" the English. Claude says they’re not worth the hype.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nobody’s going over budget with Seth and me on his case,” Stella boasted. “We know how to kick "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("major")]), _vm._v(" ass.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Such")]), _vm._v(" a lady,” James murmured.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("“Just like you, dear,” Stella retaliated.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Laughter all around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The waiter returned with Lissa’s credit card. She signed the check and got up to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where’re you rushing off to anyway?” Kyndra asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lissa decided there was no reason to tell them that she had a meeting with a private investigator, it was embarrassing enough that divorce number four might be lurking on the horizon, why tip it before it happened?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that any of them particularly liked Gregg. Even before she’d married him her friends had warned her. Kyndra had accused him of being a user; Taylor commented he hit on other women when he wasn’t with her; and Stella observed that he seemed to be extremely needy. How right they all were.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody had mentioned that apart from being a user, a flirt, and needy, he was also stone-cold broke and had been going through her money at the speed of sound. He’d lost over a million dollars on the stock market, and that was just the beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No more, because she was sure that the private investigator she’d hired would come up with plenty of incriminating evidence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Call it woman’s intuition, but she knew that marriage number four was definitely over.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HORTLY AFTER")]), _vm._v(" Lissa left the restaurant, Taylor announced she had a meeting with her writer and had to rush.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Jesus!” Stella exclaimed. “How long have you been working on this script of yours now?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("“Too long,” Taylor said with a grimace. “And I’m "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("still")]), _vm._v(" stuck in development hell.”")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Surely Larry can help?” James asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Yes,")]), _vm._v(" Taylor thought grimly. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("He can and he will.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When she’d first gotten involved with the project, she hadn’t imagined that she’d require her husband’s assistance. She’d been determined to prove to Hollywood that there was more than "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("one")]), _vm._v(" talent in the family, that she was quite capable of getting a movie off the ground by herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truth was that—dammit—she couldn’t. Hollywood was basically a boys’ town, and even though she was married to one of the boys, when she was out there operating on her own, it didn’t make any difference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was infuriating, because more than anything, Taylor craved recognition and her own identity. Hollywood knew her as Mrs. Lawrence Singer, the wife of an extraordinarily multitalented man who had three Oscars on his mantel and numerous other awards. He was a man who was well respected and well liked. And just because she was his wife (second), so was she.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry was, at fifty, only a mere sixteen years older than she—hardly an age gap in Hollywood circles, where the norm was at least twenty years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Successful men usually dumped their first wives within several years of making it big. Then they married the second, much younger wife and started another family—claiming that they would now be able to spend quality time with their new offspring, conveniently forgetting how much this self-serving statement pissed off the children of marriage number one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stella’s husband, Seth, was a classic example.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Taylor had decided that children were not on her ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("agenda for now. First, a kick-ass career, then maybe a kid or two. It wasn’t as if Larry was desperate—the one time they’d discussed it, he’d told her he didn’t care either way. He had a teenage daughter from his first marriage, and fortunately the girl resided in Hawaii with her mother, so Taylor hardly ever saw her.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("She and Larry had been married for five years. They’d lived together for eighteen months before he’d gotten his divorce—a divorce that had cost him millions. But he hadn’t seemed to mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("had")]), _vm._v(" minded. Especially when his lawyers stepped in and suggested that "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("she")]), _vm._v(" sign a prenuptial.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’d moved out of his house in a rage, had not spoken to him for days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her behavior paid off. He’d begged her forgiveness and the prenup was never mentioned again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They’d met on one of his movies. She’d had a small role, and he was king of the set. She’d gone after him from day one. Married or not, Larry Singer was destined to be her ticket to ride "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("on all")]), _vm._v(" the roundabouts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tracking him was easy—especially for an experienced player like Taylor, who’d been knocking around Hollywood for several years, snagging small roles in theatrical movies and starring in a couple of failed sitcoms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor was an ex-cheerleader who’d come to Hollywood after winning a beauty pageant. Once there, she’d managed to fuck her way to the middle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry was an extraordinarily talented, rather plain man who’d never explored his sexual potential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Taylor had helped him make the trip.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now it was his turn to help her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("She had a script that was almost right—and so it should be, she’d been working on it for long enough, ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("hiring and firing a succession of writers. When the script was exactly the way she wanted it, she planned on directing "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" playing the lead, the role of a strong woman. So far three studios had passed, and finally she’d been forced to ask Larry to come to her aid. With his kind of clout, they both knew he could get anything done.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Pending script approval, he’d set a deal for her at Orpheus Studios. God knows what he’d promised them to make the deal. She didn’t know and she didn’t care. It was her turn to shine. Her turn to get the recognition. She’d given up her acting career for Larry, and now it was time to get it back on track.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stood outside the restaurant, waiting for the valet to bring her car, a metallic-blue Jaguar that Larry had gifted her with on her last birthday.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In her mind she was just as talented as her famous husband, and it was about time the world realized it.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 78
// module chunks = 0